import { useState, useEffect, useRef, useContext } from "react";
import Slider from "react-slick";
import SideOverviewSection from "./OverviewSection";
import SideSkillsSection from "./SkillsSection";
import SideAboutSection from "./AboutSection";
import SideExperienceSection from "./ExperienceSection";
import ClosingAnimatedLayer from "../ClosingAnimatedLayer";
import { storeContext } from "../../global/store";

const settingsBase = {
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const SideLayout = () => {
  const { store, setStore } = useContext(storeContext);

  const settings_1 = {
    ...settingsBase,
    initialSlide: store.savedSlideIndex || 0, // restore on mount
    afterChange: (current) => {
      setStore((prev) => ({ ...prev, savedSlideIndex: current }));
    }, // persist on change
  };

  useEffect(() => {
    // when component mounts again, jump to saved slide
    if (sliderRef.current && store.savedSlideIndex) {
      sliderRef.current.slickGoTo(store.savedSlideIndex, true);
    }
  }, [store.savedSlideIndex]);

  const [showLayer, setShowLayer] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setShowLayer(false);
    }, 1800);
  }, []);

  let sliderRef = useRef(null);
  const eventHandler = (event) => {
    event.deltaY > 0 ? sliderRef.slickNext() : sliderRef.slickPrev();
  };

  useEffect(() => {
    document.addEventListener("wheel", eventHandler);
    return () => {
      document.removeEventListener("wheel", eventHandler);
    };
  }, []);

  return (
    <div className="gridAreaOne grid">
      <div className="opacity-100 gridAreaOne lg:w-screen lg:h-[99vh] flex flex-col lg:flex-row items-center justify-center overflow-x-hidden">
        <div className="lg:h-full w-full lg:w-1/2 screen">
          <SideOverviewSection></SideOverviewSection>
        </div>
        <div className="lg:h-full w-full lg:w-1/2 bg-gray-50 screen">
          <Slider
            className="slider"
            ref={(slider) => {
              sliderRef = slider;
            }}
            {...settings_1}
          >
            <SideSkillsSection part={1}></SideSkillsSection>
            <SideSkillsSection part={2}></SideSkillsSection>
            <SideAboutSection></SideAboutSection>
            <SideExperienceSection part={1}></SideExperienceSection>
            <SideExperienceSection part={2}></SideExperienceSection>
            <SideExperienceSection part={3}></SideExperienceSection>
          </Slider>
        </div>
      </div>
      {showLayer && <ClosingAnimatedLayer></ClosingAnimatedLayer>}
    </div>
  );
};

export default SideLayout;
